'use client'
import styles from './CookieConsentBanner.module.scss'
import classNames from 'classnames'
import { useRef, useState, useEffect } from 'react'
import CookieIcon from '@mui/icons-material/Cookie'
import CloseIcon from '@mui/icons-material/Close'
import { acceptTracking, declineTracking } from '@/lib/posthogConsent'

const COOKIE_CONSENT_KEY = 'cookie_consent'

export default function CookieConsentBanner() {
  const bannerRef = useRef<HTMLDivElement>(null)
  const [showBanner, setShowBanner] = useState(false)

  useEffect(() => {
    const consent = localStorage.getItem(COOKIE_CONSENT_KEY)
    if (!consent) {
      setShowBanner(true)
    }
  }, [])

  const handleAccept = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'accepted')
    acceptTracking()
    setShowBanner(false)
  }

  const handleDecline = () => {
    localStorage.setItem(COOKIE_CONSENT_KEY, 'declined')
    declineTracking()
    setShowBanner(false)
  }

  if (!showBanner) return null

  return (
    <div ref={bannerRef} className={classNames(styles.banner,'primary_font')}>

      <div className={styles.header}>
        <CookieIcon fontSize="small" />
        <h4>Privacy-Friendly Product Analytics</h4>
      </div>

      <p className={styles.message}>
        We use PostHog for Product Analytics, a privacy-friendly platform hosted in the EU, to improve your experience.
      </p>

      <div className={styles.details}>
        <p><strong>Privacy-First:</strong> We keep all data within the EU.</p>
        <p><strong>Single Cookie:</strong> If you opt in, we use a single first-party cookie. We do not use third-party cookies, and nothing is shared externally.</p>
        <p><strong>Strictly for Product Improvements:</strong> No ads or data sales.</p>
      </div>

      <p className={styles.footerNote}>Just a Better Product for You!</p>

      <div className={styles.buttons}>
        <button onClick={handleAccept} className={classNames(styles.button, styles.accept,'primary_font','secondary-btn-color')}>
         Accept
        </button>
        <button onClick={handleDecline} className={classNames(styles.button, styles.decline,'primary_font')}>
          Decline
        </button>
      </div>
    </div>
  )
}
